export const FLOW_TEMPLATES = [
  {
    id: 'blank',
    name: 'FLOW_BUILDER.TEMPLATES.BLANK.NAME',
    description: 'FLOW_BUILDER.TEMPLATES.BLANK.DESCRIPTION',
    icon: 'i-lucide-plus',
    flow_data: {
      nodes: [
        {
          id: 'trigger-1',
          type: 'trigger',
          position: { x: 250, y: 50 },
          data: { event: '', conditions: [] },
        },
        {
          id: 'end-1',
          type: 'end',
          position: { x: 250, y: 250 },
          data: {},
        },
      ],
      edges: [
        { id: 'e1', source: 'trigger-1', target: 'end-1' },
      ],
    },
  },
  {
    id: 'auto_assign',
    name: 'FLOW_BUILDER.TEMPLATES.AUTO_ASSIGN.NAME',
    description: 'FLOW_BUILDER.TEMPLATES.AUTO_ASSIGN.DESCRIPTION',
    icon: 'i-lucide-user-check',
    flow_data: {
      nodes: [
        {
          id: 'trigger-1',
          type: 'trigger',
          position: { x: 250, y: 50 },
          data: { event: 'conversation_created', conditions: [] },
        },
        {
          id: 'action-1',
          type: 'action',
          position: { x: 250, y: 200 },
          data: { action_name: 'assign_agent', action_params: [] },
        },
        {
          id: 'end-1',
          type: 'end',
          position: { x: 250, y: 350 },
          data: {},
        },
      ],
      edges: [
        { id: 'e1', source: 'trigger-1', target: 'action-1' },
        { id: 'e2', source: 'action-1', target: 'end-1' },
      ],
    },
  },
  {
    id: 'welcome_message',
    name: 'FLOW_BUILDER.TEMPLATES.WELCOME_MESSAGE.NAME',
    description: 'FLOW_BUILDER.TEMPLATES.WELCOME_MESSAGE.DESCRIPTION',
    icon: 'i-lucide-message-circle',
    flow_data: {
      nodes: [
        {
          id: 'trigger-1',
          type: 'trigger',
          position: { x: 250, y: 50 },
          data: { event: 'conversation_created', conditions: [] },
        },
        {
          id: 'action-1',
          type: 'action',
          position: { x: 250, y: 200 },
          data: { action_name: 'send_message', action_params: ['FLOW_BUILDER.TEMPLATES.WELCOME_MESSAGE.DEFAULT_CONTENT'] },
        },
        {
          id: 'end-1',
          type: 'end',
          position: { x: 250, y: 350 },
          data: {},
        },
      ],
      edges: [
        { id: 'e1', source: 'trigger-1', target: 'action-1' },
        { id: 'e2', source: 'action-1', target: 'end-1' },
      ],
    },
  },
  {
    id: 'conditional_route',
    name: 'FLOW_BUILDER.TEMPLATES.CONDITIONAL_ROUTE.NAME',
    description: 'FLOW_BUILDER.TEMPLATES.CONDITIONAL_ROUTE.DESCRIPTION',
    icon: 'i-lucide-git-branch',
    flow_data: {
      nodes: [
        {
          id: 'trigger-1',
          type: 'trigger',
          position: { x: 300, y: 50 },
          data: { event: 'conversation_created', conditions: [] },
        },
        {
          id: 'condition-1',
          type: 'condition',
          position: { x: 300, y: 200 },
          data: { conditions: [] },
        },
        {
          id: 'action-yes',
          type: 'action',
          position: { x: 100, y: 350 },
          data: { action_name: 'assign_team', action_params: [] },
        },
        {
          id: 'action-no',
          type: 'action',
          position: { x: 500, y: 350 },
          data: { action_name: 'assign_agent', action_params: [] },
        },
        {
          id: 'end-1',
          type: 'end',
          position: { x: 100, y: 500 },
          data: {},
        },
        {
          id: 'end-2',
          type: 'end',
          position: { x: 500, y: 500 },
          data: {},
        },
      ],
      edges: [
        { id: 'e1', source: 'trigger-1', target: 'condition-1' },
        { id: 'e2', source: 'condition-1', target: 'action-yes', sourceHandle: 'yes' },
        { id: 'e3', source: 'condition-1', target: 'action-no', sourceHandle: 'no' },
        { id: 'e4', source: 'action-yes', target: 'end-1' },
        { id: 'e5', source: 'action-no', target: 'end-2' },
      ],
    },
  },
];
